export class PojavniOblik {
  constructor() {
    //
  }

  'en~pojavni_oblik~id' = '';
  'en~pojavni_oblik~status' = '';
}

type IPojavniOblik = PojavniOblik;

export function isPojavniOblik(item: PojavniOblik): item is IPojavniOblik {
  return Object.keys(new PojavniOblik()).every(
    (key) => Object.keys(item).indexOf(key) > 0
  );
}
